import React, { useEffect } from 'react';
import { RBHBox, RBHText } from '../../../../shared/components';
import branchStyles from '../styles';
import styles from './styles';
import { FormAddEdit } from '../components/FormAddEdit';
import { Breadcrumb } from 'antd';
import { FormattedMessage } from 'react-intl';
import styleText from '../../../../shared/components/rbh-text/styles';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { mainCreators } from '../../../main-action';
import { MAIN_STATE_KEY } from '../../../main-reducer';
import { generalCreators } from '../../../../redux/general/general-action';
import { GENERAL_STATE_KEY } from '../../../../redux/general/general-reducer';
import { MODAL_TYPE } from '../../../../redux/general/general-constant';

export const AddBranchScreen: React.FC<Props> = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(mainCreators.setMainState(MAIN_STATE_KEY.HEADER_MENU, 1));
  }, []);

  const pushToMain = () => {
    history.push('/main');
  };

  const pushToBranch = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    history.push('/main/branchmanagement');
  };

  const BreadcrumbAddRender = () => {
    return (
      <RBHBox>
        <Breadcrumb style={styleText.breadCrumb}>
          <Breadcrumb.Item>
            <a data-testid='id-breadcrumb-to-home' id='id-breadcrumb-to-home' style={styleText.breadCrumbItemLink} onClick={() =>
              dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, { visible: true, onOk: pushToMain, type: MODAL_TYPE.CONFIRM_EDIT }))}>
              <FormattedMessage id={'main.main'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a data-testid='id-breadcrumb-to-branch' id='id-breadcrumb-to-branch' style={styleText.breadCrumbItemLink} onClick={() =>
              dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
                visible: true,
                onOk: pushToBranch,
                type: MODAL_TYPE.CONFIRM_EDIT
              }))}>
              <FormattedMessage id={'main.branchmanagement'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span data-testid='id-breadcrumb-addbranch' id='id-breadcrumb-addbranch' style={styleText.breadCrumbItem}>
              <FormattedMessage id={'main.addbranch'} />
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </RBHBox>
    );
  };

  return (
    <RBHBox>
      {BreadcrumbAddRender()}
      <RBHBox>
        <RBHBox style={branchStyles.header}>
          <RBHText data-testid='id-text-add-branch' id='id-text-add-branch' style={styleText.headerText} text={'main.addbranch'} />
        </RBHBox>
        <RBHBox style={styles.headerRemark}>
          <RBHText data-testid={'id-text-add-branch-remark'} id={'id-text-add-branch-remark'} style={styles.textRegular14DarkGray}
            text={'main.addbranch.remark'} />
        </RBHBox>
        <RBHBox style={styles.formWrapper}>
          <FormAddEdit onSuccessCallback={pushToBranch} onCancel={() =>
            dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
              visible: true,
              onOk: pushToBranch,
              type: MODAL_TYPE.CONFIRM_EDIT
            }))} />
        </RBHBox>
      </RBHBox>
    </RBHBox>
  );
};

type Props = {

};
